<template>
  <GmapCustomMarker :offsetY="45" :marker="marker" alignment="bottom">
    <div class="vehicle-panel" @click.stop>
      <McButton
        size="sm"
        :text="$t('fleetTaskInstant.action.assign')"
        @click="handleAssignVehicle"
      />
    </div>
  </GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import McButton from '@/components/McButton'

import { EventBus } from '../lib/event-bus.js'

export default {
  components: {
    GmapCustomMarker,
    McButton,
  },
  props: {
    vehicle: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    marker() {
      return {
        lat: this.vehicle.latitude,
        lng: this.vehicle.longitude,
      }
    },
  },
  methods: {
    handleAssignVehicle() {
      EventBus.$emit('create-fleet-task-instant', this.vehicle)
    },
  },
}
</script>

<style lang="scss" scoped>
.vehicle-panel {
  background-color: $white;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px #10184029;

  &::after {
    content: '';
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 15px solid white;
  }
}
</style>
